import { useQuery, useQueryClient } from '@tanstack/react-query';
import { TagType } from 'src/features/sites/types/types';
import { SitesService } from 'src/services/sites/sites.service';

type UseGetTagByIdArgs = {
  customerId: string;
  siteId: string;
  gatewayId: string;
  inputId: string;
};

export const useGetTagByIdQuery = ({
  customerId,
  siteId,
  gatewayId,
  inputId,
}: UseGetTagByIdArgs) => {
  const queryClient = useQueryClient();

  const isEnabled = !!customerId && !!siteId && !!gatewayId && !!inputId;

  const queryKey = isEnabled
    ? ['tag', `${customerId}-${siteId}-${gatewayId}-${inputId}`, { includeLatestValues: true }]
    : ['tag', 'empty'];

  const {
    data: tag,
    isLoading,
    isError,
  } = useQuery<TagType>({
    queryKey,
    queryFn: () => SitesService.getTagById(customerId, siteId, gatewayId, inputId, true),
    staleTime: 1000 * 60 * 1, //1 minute cache
    enabled: isEnabled,
    placeholderData: () => queryClient.getQueryData<TagType>(queryKey),
  });

  return { tag, isLoading, isError };
};
